import { useMemo } from "react";
import { useAuth } from "react-oidc-context";
import { getInitials } from "../utils/userUtils";


function signOutRedirect() {
  const clientId = "41vjsqnlqsalec316ga7hdjn76";
  const logoutUri = window.location.origin;
  const cognitoDomain = "https://eu-north-1htt4uq7xc.auth.eu-north-1.amazoncognito.com";

  window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
}


export function useCurrentUser() {
  const auth = useAuth();

  const email = auth.user?.profile?.email ?? "";
  const name = auth.user?.profile?.name || email;
  const initials = useMemo(() => getInitials(name), [name]);

  return {
    auth,
    isAuthenticated: auth.isAuthenticated,
    isLoading: auth.isLoading,
    user: auth.user,
    email,
    name,
    initials,
    signIn: () => auth.signinRedirect(),
    signOut: async () => {
      await auth.removeUser();
      signOutRedirect();
    },
  };
}